const memberEnterprises =  [
  '中电建新能源集团股份有限公司',
  '水电水利规划设计总院有限公司',
  '中国电建集团海外投资有限公司',
  '中国电建集团国际工程有限公司',
  '中电建国际贸易服务有限公司',
  '中电建国际贸易服务有限公司',
  '中电建建筑集团有限公司',
  '中国水电基础局有限公司',
  '中电建路桥集团有限公司',
  '中国电建地产集团有限公司',
  '中电建铁路建设投资集团有限公司',
  '中国电建集团港航建设有限公司',
  '中国电建集团租赁有限公司',
  '中国电建集团财务有限责任公司',
  '中电建（北京）基金管理有限公司',
  '中电建商业保理有限公司',
  '中国电建集团北京勘测设计研究院有限公司',
  '北京华科软科技有限公司',
  '中国电建市政建设集团有限公司',
  '中国电建集团河北省电力勘测设计研究院有限公司',
  '中国电建集团河北工程有限公司',
  '中国电建集团北方投资有限公司',
  '中国水务投资有限公司',
  '中国电建集团核电工程有限公司',
  '中国水利水电第十二工程局有限公司',
  '中国水利水电第十二工程局有限公司',
  '山东电力建设第三工程有限公司',
  '上海电力建设有限责任公司',
  '中国电建集团华东勘测设计研究院有限公司',
  '上海电力设计院有限公司',
  '中国电建集团山东电力建设有限公司',
  '中国电建集团山东电力建设第一工程有限公司',
  '中国电建集团航空港建设有限公司',
  '中国水利水电第一工程局有限公司',
  '中国水利水电第六工程局有限公司',
  '中国电建集团吉林省电力勘测设计院有限公司',
  '中国水利水电第三工程局有限公司',
  '中国水利水电第四工程局有限公司',
  '中国水电建设集团十五工程局有限公司',
  '中国电建集团甘肃能源投资有限公司',
  '中国电建集团西北勘测设计研究院有限公司',
  '中国电建集团青海省电力设计院有限公司',
  '中国电建集团西部区域总部',
  '中国水利水电第五工程局有限公司',
  '中国水利水电第七工程局有限公司',
  '中国水利水电第九工程局有限公司',
  '中国水利水电第十工程局有限公司',
  '中国水利水电第十四工程局有限公司',
  '中电建水电开发集团有限公司',
  '中国电建集团成都勘测设计研究院有限公司',
  '中国电建集团贵阳勘测设计研究院有限公司',
  '中国电建集团昆明勘测设计研究院有限公司',
  '四川电力设计咨询有限公司',
  '中国电建集团贵州电力设计研究院有限公司',
  '中国电建集团重庆工程有限公司',
  '中国电建集团贵州工程有限公司',
  '中电建重庆投资有限公司',
  '中电建装备集团有限公司',
  '中国电建集团华中电力设计研究院有限公司',
  '中国水利水电第八工程局有限公司',
  '中国水利水电第十一工程局有限公司',
  '中国电建集团中南勘测设计研究院有限公司',
  '中国电建集团湖北工程有限公司',
  '中国电建集团江西省电力设计院有限公司',
  '中国电建集团河南工程有限公司',
  '中国电建集团江西省电力建设有限公司',
  '中国电建集团江西省水电工程局有限公司',
  '中国电建集团南方区域总部/南方投资公司',
  '中国水利水电第十六工程局有限公司',
  '中国电建生态环境集团有限公司',
  '中国电建集团福建省电力勘测设计院有限公司'
]

export default memberEnterprises;
